<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirm-loading="isSubmitting"
    @ok="handleConfirm"
    @cancel="handleCancel"
  >
    <a-form-model
      style="padding-right: 30px"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 19 }"
    >
      <a-form-model-item :label="$t('saleDocument.modal.FWLX')" prop="fwlx" required>
        <a-select v-model="form.fwlx" @change="handleFWLXChange">
          <a-select-option
            value="0"
          >
            {{ $t('saleDocument.modal.DM') }}
          </a-select-option>
          <a-select-option
            value="1"
          >
            {{ $t('saleDocument.modal.el') }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('saleDocument.serviceType')" prop="serviceType">
        <a-select v-model="form.serviceType">
          <a-select-option
            v-for="(v, k) in typeMap"
            :key="k"
          >
            {{ v }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('common.deviceCode')" prop="equipmentId">
        <a-select
          v-if="form.fwlx === '0'"
          v-model="form.equipmentId"
          show-search
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          @inputKeydown="searchDevice"
          @popupScroll="handleDevicePopupScroll"
          @change="isCustomerDisabled = true"
        >
          <a-select-option @click.native="selectDevice(d)" v-for="d in devices" :key="d.id">
            {{ d.name }} - {{ d.code }} - {{ d.model }}
          </a-select-option>
        </a-select>
        <a-input v-else v-model="form.sbbh" @blur="form.equipmentId = form.sbbh" />
      </a-form-model-item>
      <a-form-model-item v-if="form.fwlx === '0'" :label="$t('common.deviceName')" required>
        <a-input v-model="deviceName" />
      </a-form-model-item>
      <a-form-model-item v-else :label="$t('common.deviceName')" prop="sbmc">
        <a-input v-model="form.sbmc" />
      </a-form-model-item>
      <a-form-model-item v-if="form.fwlx === '0'" :label="$t('saleDocument.modal.sbxh')" required>
        <a-input v-model="model" />
      </a-form-model-item>
      <a-form-model-item v-else :label="$t('saleDocument.modal.sbxh')" prop="sbxh">
        <a-input v-model="form.sbxh" />
      </a-form-model-item>
      <a-form-model-item :label="$t('customer.company')" prop="customerId">
        <a-select
          v-if="form.fwlx === '0'"
          v-model="form.customerId"
          show-search
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :disabled="this.title === $t('saleDocument.editTitle')"
          @inputKeydown="searchCustomer"
          @popupScroll="handleCustomerPopupScroll"
        >
          <a-select-option v-for="c in customers" :key="c.id" @click.native="selectC(c)">
            {{ c.company }}
          </a-select-option>
        </a-select>
        <a-select
          v-else
          v-model="gsmc"
          show-search
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :disabled="this.title === $t('saleDocument.editTitle')"
          :default-value="form.gsmc"
          @inputKeydown="searchCustomerO"
        >
          <a-select-option v-for="c in customers" :key="c.id" @click.native="selectCO(c)">
            {{ c.company }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('common.customer')" v-if="form.fwlx === '0'">
        <!-- <a-input v-model="form.contactPerson" /> -->
        <a-select v-model="contactPerson" option-label-prop="label">
          <a-select-option v-for="u in users" :label="u.realName" :key="u.realName" @click.native="selectUser(u)">
            {{ u.realName }} - {{ u.username }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('customer.address')" v-else required>
        <a-input v-model="form.gsdz" />
      </a-form-model-item>
      <a-form-model-item :label="$t('orders.contactPerson')">
        <a-input v-model="form.contactPerson" />
      </a-form-model-item>
      <a-form-model-item :label="$t('customer.mobile')">
        <a-input v-model="form.mobile" />
      </a-form-model-item>
      <a-form-model-item :label="$t('saleDocument.modal.runTime')">
        <a-input v-model="form.runTime" />
      </a-form-model-item>
      <a-form-model-item :label="$t('common.remark')">
        <a-input v-model="form.note" />
      </a-form-model-item>
      <a-form-model-item :label="$t('saleDocument.modal.servicehours')">
        <a-input v-model="form.servicehours" />
      </a-form-model-item>
      <a-form-model-item :label="$t('saleDocument.modal.serviceContent')">
        <a-input v-model="form.serviceContent" />
      </a-form-model-item>
      <a-form-model-item :label="$t('common.serviceMen')">
        <a-input v-model="form.serviceman" />
      </a-form-model-item>
      <!-- <a-form-model-item label="服务时间">
        <a-date-picker placeholder="" @change="selectFinishTime" style="width: 100%" show-time />
      </a-form-model-item> -->
      <a-form-model-item :label="$t('common.picture')" label-width="100px">
        <div class="upload">
          <button
            aria-disabled="false"
            type="button"
            class="el-button el-button"
            :key="fileList.length"
          >
            <span style="padding: 8px 15px;" class="" @click="showFileModal"
              ><i class="el-icon-upload"></i>&nbsp;&nbsp;{{ $t('buttons.uploadPic') }}</span
            >
          </button>
          <input
            ref="InputFileDOm"
            class="file"
            type="file"
            :accept="'.mp4,.jpg,.jpeg,.png,.webm'"
            :limit="6"
            @change="hadnleFileCHnage($event, '0')"
            multiple
          />
          <div class="upload-demo" data-v-1ab1ffd8="">
            <ul
              class="el-upload-list el-upload-list--text"
              :key="fileList.length"
            >
              <li
                tabindex="0"
                v-for="(file, index) in fileList"
                :key="srcList[index].path"
                style="float: left;width: 100px; height: 100px; position: relative"
                @mouseover="srcList[index].isMaskShow = true; $forceUpdate()"
                @mouseleave="srcList[index].isMaskShow = false; $forceUpdate()"
              >
                <div v-show="srcList[index].isMaskShow" class="mask" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, .3); z-index: 100; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <a-icon type="eye" style="color: #ccc; font-size: 20px; margin-right: 10px" @click="previewImg(index)" />
                  <a-icon type="delete" style="color: #ccc; font-size: 20px" @click="rF(index)" />
                </div>
                <img :src="srcList[index].path" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer" />
              </li>
            </ul>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('common.audio')" label-width="100px">
        <div class="upload">
          <button
            aria-disabled="false"
            type="button"
            class="el-button el-button"
            :key="fileList.length"
          >
            <span style="padding: 8px 15px;" class="" @click="showFileModal1"
              ><i class="el-icon-upload"></i>&nbsp;&nbsp;{{ $t('buttons.uploadAud') }}</span
            >
          </button>
          <input
            ref="InputFileDOm1"
            class="file"
            type="file"
            :accept="'.m4v'"
            :limit="6"
            @change="hadnleFileCHnage1($event, '0')"
            multiple
          />
          <div class="upload-demo" data-v-1ab1ffd8="">
            <ul
              class="el-upload-list el-upload-list--text"
              :key="fileList.length"
            >
              <li
                tabindex="0"
                v-for="(file, index) in audioFileList"
                :key="audioList[index].path"
                style="position: relative"
                class="upload-item"
              >
                <audio controls>
                  <source :src="audioList[index].path" type="video/mp4">
                  {{ $t('messages.unspportedAudio') }}
                </audio>
                <a @click="ra(index)">{{ $t('buttons.delete') }}</a>
              </li>
            </ul>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { searchDeviceList } from '@/api/device'
import { searchCustomerList, getCustomerById } from '@/api/customer'
import { add, update, getRunTime } from '@/api/service'
import {
  findConpany,
  findThisConpany
} from "@/api/crm";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    typeMap: {
      type: Object,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    record: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      form: {
        serviceType: '',
        equipmentId: '',
        customerId: '',
        servicehours: '',
        serviceContent: '',
        serviceman: localStorage.getItem('nick') || '',
        // serviceTime: '',
        contactPerson: '',
        mobile: '',
        runTime: '',
        fwlx: '0',
        sbbh: '',
        sbmc: '',
        sbxh: '',
        note: '',
        gsmc: '',
        gsdz: ''
      },
      gsmc: '',
      devices: [],
      deviceName: '',
      model: '',
      files: [],
      customer: '',
      customers: [],
      rules: {
        serviceType: [
          {
            required: true,
            message: this.$t('messages.selectServiceType')
          }
        ],
        equipmentId: [
          {
            required: true,
            message: this.$t('messages.selectDevice')
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        servicehours: [
          {
            required: true,
            message: this.$t('messages.enterServicehours')
          }
        ],
        serviceContent: [
          {
            required: true,
            message: this.$t('messages.enterServiceContent')
          }
        ],
        serviceman: [
          {
            required: true,
            message: this.$t('messages.enterServiceMan')
          }
        ]
        // serviceTime: [
        //   {
        //     required: true,
        //     message: '请选择服务时间'
        //   }
        // ]
      },
      isSubmitting: false,
      fileList: [],
      anniu: false,
      srcList: [],
      delField: [],
      previewList: [],
      audioFileList: [],
      audioList: [],
      users: [],
      isRunTimeShow: false,
      contactPerson: ''
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
        if (this.record) {
          for (let k in this.form) {
            this.form[k] = this.record[k]
          }
          this.form.fwlx = this.form.fwlx || '0'
          delete this.rules.customerId
          this.customers = [
            {
              id: this.record.customerId,
              company: this.record.customer
            }
          ]
          this.devices = [
            {
              id: this.record.equipmentId,
              name: this.record.equipmentName,
              code: this.record.equipmentCode,
              model: this.record.equipmentModel,
              customer: this.customers[0],
              customerId: this.record.customerId,
              protocolCode: this.record.protocolCode,
              type: this.record.type
            }
          ]
          if (this.record.id) {
            this.form.id = this.record.id
            if (this.form.fwlx === '0') {
              this.selectDevice(this.devices[0])
              this.customer = this.record.customer
              this.fileList = []
              this.srcList = []
              this.audioFileList = []
              this.audioList = []
              this.record.files.forEach(f => {
                if (f.path.endsWith('.m4v') || f.path.endsWith('.m4a')) {
                  this.audioFileList.push(f)
                  this.audioList.push({
                    isMaskShow: false,
                    path: f.path
                  })
                } else {
                  this.fileList.push(f)
                  this.srcList.push({
                    isMaskShow: false,
                    path: f.path
                  })
                }
              })
              this.form.servicehours = this.record.servicehours || ''
              this.contactPerson = this.record.contactPerson
            }
            if (this.form.fwlx === '1') {
              this.form.equipmentId = this.form.sbbh
              this.form.customerId = this.form.gsmc
              this.gsmc = this.form.gsmc
            }
            this.handleFWLXChange('1')
          } else {
            this.form.serviceman = localStorage.getItem('nick') || ''
          }
        } else {
          this.rules.customerId = [
            {
              required: true,
              message: this.$t('messages.pec')
            }
          ]
          this.form.serviceman = localStorage.getItem('nick') || ''
        }
      }
    }
  },
  methods: {
    async searchDevice(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.target.value = e.target.value.trim()
        this.ds = e.target.value
        this.dSearchFlag = true
        this.devicePage = 1
        const params = {
          query: [
            {
              field: 'code',
              value: this.ds
            }
          ],
          filter: [],
          sort: []
        }
        try {
          const { data } = await searchDeviceList(1, 10, params)
          this.devices = data.records
        } catch(e) {
          console.log(e)
        }
      }
    },
    async handleDevicePopupScroll(e){
      if (this.dSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if(scrollHeight - scrollTop === clientHeight){
          this.devicePage++
          const params = {
            query: [
              {
                field: 'code',
                value: this.ds
              }
            ],
            filter: [],
            sort: []
          }
          const { data } = await searchDeviceList(this.devicePage, 10, params)
          this.devices = this.devices.concat(data.records)
          if (this.devices.length >= data.total) {
            this.dSearchFlag = false
          }
        }
      }
    },
    async selectDevice(d) {
      this.form.equipmentId = d.id
      this.deviceName = d.name
      this.model = d.model
      this.customers = [d.customer]
      this.form.customerId = d.customerId
      const { data } = await getCustomerById(d.customerId)
      this.users = data.users || []
      if (this.users.length) {
        this.contactPerson = this.form.contactPerson = this.users[0].realName
        this.form.mobile = this.users[0].username
      }
      if (!d.type) {
        const { data } = await searchDeviceList(1, 10, {
          query: [],
          filter: [{
            field: 'code',
            value: d.code
          }],
          sort: []
        })
        d.type = data.records[0].type
      }
      if (d.type === 'KYJ') {
        this.isRunTimeShow = true
        if (this?.record?.runTime) {
          this.form.runTime = this.record.runTime
        } else if (!this?.record?.id) {
          const { data } = await getRunTime({
            equipmentCode: d.code,
            protocolCode: d.protocolCode
          })
          this.form.runTime = data
        }
      } else {
        this.isRunTimeShow = false
      }
    },
    selectUser(u) {
      this.form.contactPerson = u.realName
      this.form.mobile = u.username
    },
    async searchCustomer(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.target.value = e.target.value.trim()
        this.cs = e.target.value
        this.cSearchFlag = true
        this.customerPage = 1
        try {
          const { data } = await searchCustomerList(1, 10, {
            query: [
              {
                field: 'company',
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          })
          this.customers = data.records
        } catch(e) {
          console.log(e)
        }
      }
    },
    async searchCustomerO(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        e.target.value = e.target.value.trim()
        try {
          const { data } = await findConpany("1", "20", e.target.value)
          this.customers = data.records.map(r => ({
            id: r.id,
            company: r.name
          }))
        } catch(e) {
          console.log(e)
        }
      }
    },
    async handleCustomerPopupScroll(e){
      if (this.cSearchFlag) {
        const { scrollHeight, scrollTop, clientHeight } = e.target
        if(scrollHeight - scrollTop === clientHeight){
          this.customerPage++
          const { data } = await searchCustomerList(this.customerPage, 10, {
            query: [
              {
                field: 'company',
                value: this.cs
              }
            ],
            filter: [],
            sort: []
          })
          this.customers = this.customers.concat(data.records)
          if (this.customers.length >= data.total) {
            this.cSearchFlag = false
          }
        }
      }
    },
    clearForm() {
      this.customers = []
      this.devices = []
      this.form = {
        serviceType: '',
        equipmentId: '',
        customerId: '',
        servicehours: '',
        serviceContent: '',
        serviceman: localStorage.getItem('nick') || '',
        contactPerson: '',
        mobile: '',
        runTime: '',
        fwlx: '0',
        sbbh: '',
        sbmc: '',
        sbxh: '',
        note: '',
        gsmc: '',
        gsdz: ''
      }
      this.deviceName = ''
      this.model = ''
      this.fileList = []
      this.srcList = []
      this.audioFileList = []
      this.audioList = []
      this.delField = []
      this.users = []
      this.isRunTimeShow = false
      this.contactPerson = ''
      this.gsmc = ''
    },
    handleFWLXChange(value) {
      if (value === '0') {
        this.rules.equipmentId[0].message = this.$t('messages.selectDevice')
        if (!this.rules.customerId) {
          this.rules.customerId = [{
            required: true,
            message: this.$t('messages.pec')
          }]
        }
        this.rules.customerId[0].message = this.$t('messages.pec')
        delete this.rules.sbmc
        delete this.rules.sbxh
      }
      if (value === '1') {
        this.rules.equipmentId[0].message = this.$t('messages.pedc')
        if (!this.rules.customerId) {
          this.rules.customerId = [{
            required: true,
            message: this.$t('messages.company_empty')
          }]
        }
        this.rules.customerId[0].message = this.$t('messages.company_empty')
        this.rules.sbmc = [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: 'blur'
          }
        ]
        this.rules.sbxh = [
          {
            required: true,
            message: this.$t('messages.enterModel'),
            trigger: 'blur'
          }
        ]
      }
    },
    handleConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (((this.form.servicehours + '') && isNaN(+this.form.servicehours)) || ((this.form.runTime + '') && isNaN(+this.form.runTime))) {
            return this.$message.error(this.$t('messages.enterhoursNumber'))
          }
          try {
            const form = {...this.form}
            for (let key in form) {
              if (!form[key]) {
                form[key] = ''
              }
            }
            if (form.fwlx === '1') {
              form.customerId = ''
              form.equipmentId = ''
            }
            if (!this.isRunTimeShow || !form.runTime) {
              delete form.runTime
            }
            if (this.form.id) {
              form.delFileId = this.delField
              delete form.customerId
              const { message } = await update(form, this.fileList.concat(this.audioFileList).filter(f => !f.id))
              this.$message.success(message)
            } else {
              const { message } = await add(form, this.fileList.concat(this.audioFileList))
              this.$message.success(message)
            }
            this.clearForm()
            this.closeModal(true)
          } catch(e) {
            console.log(e)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
    handleCancel() {
      this.clearForm()
      this.closeModal()
    },
    selectFinishTime(_, b) {
      console.log(b)
      this.form.serviceTime = b
    },
    onBeforeUpload(file) {
      let acceptTypes;

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ];

      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t('messages.lessThan500MB')
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t('messages.rightFile')
        });
        return false; // 停止上传
      }
      return true;
    },
    showFileModal() {
      this.$refs.InputFileDOm.click()
    },
    showFileModal1() {
      this.$refs.InputFileDOm1.click()
    },
    hadnleFileCHnage(e) {
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList = this.fileList.concat(Array.from(e.target.files))
        this.srcList = this.fileList.map(f => {
          if (f.id) {
            return f
          } else {
            return {
              path: '',
              isMaskShow: false
            }
          }
        })
        this.fileList.forEach((f, i) => {
          if (!f.id) {
            const fr = new FileReader()
            fr.readAsDataURL(f)
            fr.onload = e => {
              this.srcList[i] = {
                path: "data:image/png;base64," + e.target.result.substring(e.target.result.indexOf(',') + 1),
                isMaskShow: false
              }
              this.$forceUpdate()
            }
          }
        })
      }
    },
    hadnleFileCHnage1(e) {
      let i
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.audioFileList = this.audioFileList.concat(Array.from(e.target.files))
        this.audioList = this.audioFileList.map(f => {
          if (f.id) {
            return f
          } else {
            return {
              path: '',
              isMaskShow: false
            }
          }
        })
      }
      this.audioFileList.forEach((f, i) => {
        if (!f.id) {
          this.audioList[i] = {
            path: URL.createObjectURL(f),
            isMaskShow: false
          }
        }
      })
    },
    rF(i) {
      this.$Mconfirm(this.$t('messages.ctrp'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(() => {
          console.log(this.fileList[i]);
          if (this.fileList[i].id) {
            this.delField.push(this.fileList[i].id)
          }
          const arr = [...this.fileList];
          arr.splice(i, 1);
          this.srcList.splice(i, 1)
          this.fileList = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    ra(i) {
      this.$Mconfirm(this.$t('messages.ctraudio'), this.$t('messages.hint'), {
        confirmButtonText: this.$t('common.okText'),
        cancelButtonText: this.$t('common.cancelText'),
        type: "warning"
      })
        .then(() => {
          if (this.audioFileList[i].id) {
            this.delField.push(this.audioFileList[i].id)
          }
          const arr = [...this.audioFileList];
          arr.splice(i, 1);
          this.audioList.splice(i, 1)
          this.audioFileList = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t('messages.rs')
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('messages.cr')
          });
        });
    },
    previewImg(i) {
      const imgList = this.srcList.map(s => s.path)
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: i,
        imgList
      })
    },
    async selectC(c) {
      const { data } = await getCustomerById(c.id)
      this.users = data.users || []
      if (this.users.length) {
        this.form.contactPerson = this.users[0].realName
        this.form.mobile = this.users[0].username
      } else {
        this.form.contactPerson = this.form.mobile = ''
      }
    },
    async selectCO(c) {
      this.form.customerId = c.id
      this.form.gsmc = c.company
      const { data } = await findThisConpany(c.company)
      this.form.gsdz = data.regLocation
    }
  }
}
</script>

<style lang="less" scoped>
input.file {
  display: none;
}
.el-upload-list__item {
  display: flex;
  justify-content: space-between;
}
.upload-item {
  display: flex;
  width: 60%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
/deep/ .ant-modal-body {
  height: 600px;
  overflow: auto;
}
</style>